// @ts-nocheck
import { FC, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { isNotEmpty } from '../../../../../_dashboard/helpers';
import { Agency } from '../core/_models';
import clsx from 'clsx';
import { useListView } from '../core/ListViewProvider';
import { DataLoading } from '../../../../../_dashboard/partials/components/loading/DataLoading';
import { useQueryResponse } from '../core/QueryResponseProvider';
import { createOne, getOneById, updateOne } from '../../../../services/common_requests';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';

type Props = {
  isAgencyLoading: boolean;
  Agency: Agency;
};

const editAgencySchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  address: Yup.string().required('Address is required'),
  city: Yup.string().required('City is required'),
  phone: Yup.string().required('Phone is required'),
});

const AgencyEditModalForm: FC<Props> = ({ Agency, isAgencyLoading }) => {
  const { itemIdForUpdate, setItemIdForUpdate } = useListView();
  const { refetchData } = useQueryResponse();
  const intl = useIntl();
  const [agencyForEdit] = useState<Agency>({ ...Agency });

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) refetchData();
    setItemIdForUpdate(undefined);
  };

  const formik = useFormik({
    initialValues: agencyForEdit,
    validationSchema: editAgencySchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      try {
        const response = isNotEmpty(itemIdForUpdate)
          ? await updateOne(values, `/agencies/${itemIdForUpdate}`)
          : await createOne(values, '/agencies');

        if (response?.payload?.code === 2021 || response?.payload?.code === 201) {
          toast.success(intl.formatMessage({ id: 'ADMIN.COMMON.SUCCESS.SUCCESSFULLY_UPDATED' }));
          cancel(true);
        } else {
          toast.error(response?.payload?.message || intl.formatMessage({ id: 'ADMIN.COMMON.ERROR.ERROR_ADDING_OPTION' }));
        }
      } catch (error) {
        toast.error(intl.formatMessage({ id: 'ADMIN.COMMON.ERROR.ERROR_ADDING_OPTION' }));
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <>
      <form className='form' onSubmit={formik.handleSubmit} noValidate>
        <div className='d-flex flex-column scroll-y me-n15 pe-6'>
          {['name', 'address', 'city', 'phone', 'email', 'contactPerson', 'openingHours', 'notes'].map((field) => (
            <div className='fv-row mb-4' key={field}>
              <label className='fw-bold fs-6 mb-2'>{field}</label>
              <input
                {...formik.getFieldProps(field)}
                className={clsx('form-control', { 'is-invalid': formik.touched[field] && formik.errors[field] })}
                disabled={formik.isSubmitting || isAgencyLoading}
              />
            </div>
          ))}
          <div className='form-check form-switch mb-4'>
            <input
              className='form-check-input'
              type='checkbox'
              checked={formik.values.isActive}
              onChange={() => formik.setFieldValue('isActive', !formik.values.isActive)}
            />
            <label className='form-check-label'>Active</label>
          </div>
        </div>
        <div className='text-center pt-15'>
          <button type='reset' onClick={() => cancel()} className='btn btn-light me-3' disabled={formik.isSubmitting}>
            {intl.formatMessage({ id: 'HEADER.RESET' })}
          </button>
          <button type='submit' className='btn btn-primary' disabled={formik.isSubmitting || isAgencyLoading}>
            {intl.formatMessage({ id: 'HEADER.SAVE' })}
          </button>
        </div>
      </form>
      {(formik.isSubmitting || isAgencyLoading) && <DataLoading />}
    </>
  );
};

export { AgencyEditModalForm };
